import { useLocation } from "react-router-dom";
import qs from 'qs';

export function useQuery() {
  const { search } = useLocation();
  return qs.parse(search);
}
